import {Component, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ModalService} from 'src/app/ui-library/modal/modal.service';
import {EmploymentService} from '../../employment/employment.service';
import {Relation, RelationRole} from '../../employment/employment.model';

@Component({
    selector: 'app-team-status',
    templateUrl: './team-status.component.html',
    styleUrls: ['./team-status.component.scss'],
    standalone: false
})
export class TeamStatusComponent {

    @Input() relation: Relation;
    @Input() companionName: string;

    public isLoading$ = new BehaviorSubject<boolean>(false);

    constructor(private _employment: EmploymentService, private modal: ModalService) {
    }

    get isInTeam(): boolean {
        return this.relation
            && this.relation.inTeam;
    }

    get readyForTeam(): boolean {
        return this.relation && this.relation.allowedAction === 'AddToTeamOrDecline';
    }

    get readyForDecline(): boolean {
        return this.relation && this.relation.allowedAction === 'Decline';
    }

    get readyForTeamRemoval(): boolean {
        return this.relation && this.relation.allowedAction === 'RemoveFromTeam';
    }

    get isPA(): boolean {
        return !!(this.relation && this.relation.memberRole === 'Employer');
    }

    private get _myRole(): RelationRole {
        return this.relation && this.relation.memberRole === 'Employee' ? 'Employer' : 'Employee';
    }

    async ivite(): Promise<void> {
        this.isLoading$.next(true);

        this._employment.addToTeam(this.relation).subscribe({
            complete: () => {
                this.isLoading$.next(false);
            },
            error: (ex) => {
                this.isLoading$.next(false);
            }
        });
    }

    async removeFromTeam(): Promise<void> {
        const title = this.isPA
            ? $localize`:@@employment.popup.requestLeaveTeamTitle:Aus Team austreten?`
            : $localize`:@@employment.popup.requestRemoveFromTeamTitle:Person aus Team entfernen?`;
        const body = this.isPA
            ? $localize`:@@employment.popup.requestLeaveTeamBody:Wenn Sie bestätigen, treten Sie aus dem Team aus. Der gegenseitige Zugriff auf die vollständigen Profile wird damit auch rückgängig gemacht.`
            : $localize`:@@employment.popup.requestRemoveFromTeamBody:Wenns sie Bestätigen, wird die Person aus dem Team entfernt. Der gegenseitige Zugriff auf die vollständigen Profile wird damit auch rückgängig gemacht.`;
        const btn = this.isPA
            ? $localize`:@@employment.popup.requestLeaveTeamBtn:Austreten`
            : $localize`:@@employment.conversation.btnRemoveFromTeam:Person entfernen`;

        const confirmed = await this.modal.showCustomConfirmation(
            title,
            body,
            '/assets/images/illustration-58.svg',
            btn,
        );

        if (!confirmed) {
            return;
        }

        this.isLoading$.next(true);

        this._employment.removeFromTeam(this._myRole, this.relation).subscribe({
            complete: () => {
                this.isLoading$.next(false);
            },
            error: (ex) => {
                this.isLoading$.next(false);
            }
        });
    }
}
